import React from 'react';
import logoKiper from '../../assets/images/logo-kiper.svg';
import logoPorter from '../../assets/images/logo-porter.svg';
import runtimeConfig from '../../utils/runtime';

const logoImage = !runtimeConfig.RAZZLE_PROJECT || runtimeConfig.RAZZLE_PROJECT === 'kiper' ? logoKiper : logoPorter;

const Loader = () => (
  <div className="d-flex align-items-center justify-content-center h-100 flex-column p-3" style={{ height: '100vh' }}>
    <img src={logoImage} alt="logo" />
    <div className="justify-content-center align-self-center d-flex p-3">
      <h4>Carregando</h4>
    </div>
  </div>
);

export default Loader;
